import { Link } from 'gatsby';
import React from 'react';
import team1 from '../../assets/images/our-people/avadhani.jpg';
import team10 from '../../assets/images/our-people/divyarani.jpg';
import team11 from '../../assets/images/our-people/charishma.jpg';
import team12 from '../../assets/images/our-people/kruthika.jpg';
import team13 from '../../assets/images/our-people/mrunalini.jpg';
import team14 from '../../assets/images/our-people/srinidhi.jpg';
import team15 from '../../assets/images/our-people/kiran.jpg';
import team19 from '../../assets/images/our-people/rajani.png';
import team20 from '../../assets/images/our-people/srinitya.png';
import team21 from '../../assets/images/our-people/kathyayan.png';
import team22 from '../../assets/images/our-people/nambi.png';
import team2 from '../../assets/images/our-people/vijay.jpg';
import team3 from '../../assets/images/our-people/shoubhagya.jpg';
import team4 from '../../assets/images/our-people/nithin.jpg';
import team6 from '../../assets/images/our-people/prabha.jpg';
import team7 from '../../assets/images/our-people/juber.jpg';
import team8 from '../../assets/images/our-people/divya.jpg';
import team23 from '../../assets/images/our-people/VaishnaviSingh.jpg';
import team24 from '../../assets/images/our-people/HaripriyaIppili.jpg';
import team25 from '../../assets/images/our-people/SivaPrasadRdy.jpg';

const TeamOne = () => {
  return (
    <section className='team-one team-one__become-teacher' id='team-section'>
      <div className='container'>
        <div className='block-title text-center'>
          <h2 className='block-title__title'>
            OUR PEOPLE <br />
          </h2>
        </div>
        <div className='row'>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team1} alt='' />
              </div>
              <div className='team-one__content avadhani'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/avadani'>
                    Mr. V.S.R. Avadhani. BSC.,BL.
                  </Link>
                </h2>
                <p className='team-one__designation'>
                  Senior Partner, Senior Consultant and Advocate
                </p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team2} alt='' />
              </div>
              <div className='team-one__content vijay'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/vijay'>
                    Mr. K Vijay Bhaskar Reddy, LLM.,{' '}
                  </Link>
                </h2>
                <p className='team-one__designation'>
                  Partner, Sr. Consultant and Advocate
                </p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team3} alt='' />
              </div>
              <div className='team-one__content valli'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/soubhagya'>
                    Mrs. V Soubhagya Valli. LLM (UK)
                  </Link>
                </h2>
                <p className='team-one__designation'>
                  Partner, Sr. Consultant & Advocate
                </p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team4} alt='' />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/nithin'>
                    Mr. Nithin Chowdary Pavuluri. B.A., LLB.Hons.
                  </Link>
                </h2>
                <p className='team-one__designation'>
                  Partner, Consultant & Advocate
                </p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team7} alt='' />
              </div>
              <div className='team-one__content juber'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/juber'>
                    Mr. S.A.Juber Hussain. B.A. LLB. (HONS).
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team8} alt='' />
              </div>
              <div className='team-one__content divya'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/divya'>
                    {' '}
                    Ms. Divya Dokka. BTech., LLB.
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>

          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team10} alt='' />
              </div>
              <div className='team-one__content divya'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/divyaRani'>Mrs. R. Divya Rani, LLM</Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team11} alt='' />
              </div>
              <div className='team-one__content divya'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/charishma'>
                    Ms. Charishma Atla, LLB.
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team12} alt='' />
              </div>
              <div className='team-one__content divya'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/kruthika'>
                    Ms. Kruthika Kandhala. BBA LLB
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          {/* <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team15} alt='' />
              </div>
              <div className='team-one__content divya'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/mrunalini'>Mrunalini Eitikela, LLM</Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div> */}
          {/* <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team14} alt='' />
              </div>
              <div className='team-one__content divya'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/srinidhi'>
                    B. Srinidhi. BBA LLB (Hons.)
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div> */}
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team15} alt='' />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/kiran'>Mr. P. Kiran Kumar BA.LLB</Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>  
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img
                  src={team19}
                  alt='Ms. B. Rajani Rathod' 
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/rajani'>
                    Ms. B. Rajani Rathod. LLB
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img 
                  src={team20} 
                  alt='Srinitya Jaiteerth Joshi' 
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/srinitya'>
                    SRINITYA JAITEERTH JOSHI. LLM
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img 
                  src={team21} 
                  alt='N. Kathyayan Reddy' 
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/kathyayan'>
                    N. KATHYAYAN REDDY, LLM International Law (UK)
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img 
                  src={team22} 
                  alt='Nambi Krishna Dwaipayan' 
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/nambi'>
                    NAMBI KRISHNA DWAIPAYAN. Btech., LLB
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team23} alt='Kenvar Vaishnavi Singh' />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/VaishnaviSingh'>
                    Kenvar Vaishnavi Singh. B.A., LLB
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team24} alt='Hari Priya Ippili' />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/HariPriya_I'>
                    Ms. Hari Priya Ippili. BBA, LLB, LLM
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team25} alt='Siva Prasad Reddy Singapuram' />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/SivaPrasadRS'>
                    Mr. Shiva Prasad Reddy Singapuram. BBA, LLB
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>

          {/* <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team9} alt='' />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/venkat'>
                    B. Venkat Durga Pradeep. BCOM., LLB.
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div> */}

          {/* <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12'>
            <div className='team-one__single'>
              <div className='team-one__image'>
                <img src={team9} alt='' />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  <Link to='/advocates/venkat'>
                    B. Venkat Durga Pradeep. BCOM., LLB.
                  </Link>
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default TeamOne;
